import React from 'react'
import Button from '../../../components/Button'
import { Link, useHistory } from 'react-router-dom'
import styles from './JobNavigation.sass'

interface JobNavigationProps {
  previous?: string
  next?: string
  canProceed?: boolean
}

export default function JobNavigation({
  previous,
  next,
  canProceed,
}: JobNavigationProps) {
  const navigation = useHistory()

  return (
    <div className={styles.root}>
      <div className={styles.buttonContainer}>
        {previous && (
          <Link to={previous}>
            <Button type="secondary">Previous</Button>
          </Link>
        )}
      </div>

      <div className={styles.buttonContainer}>
        {next && (
          <Button
            onClick={() => navigation.push(next)}
            disabled={!canProceed}
            type="primary"
          >
            Next
          </Button>
        )}
      </div>
    </div>
  )
}
